import { Query } from "@syncfusion/ej2-data";

export default function DropdownFiltering(args, dataSource, fieldName) {
    let query = new Query();
    query = (args.text !== "") ? query.where(fieldName, "contains", args.text, true) : query;
    args.updateData(dataSource, query);
}